import { useEffect, useRef } from 'react'
import { useNotifications } from './use-notifications'

export function useNotificationLifecycle(userId: string | null | undefined) {
	const { unsubscribe } = useNotifications({ userId: userId || undefined })
	const previousUserIdRef = useRef<string | null>(null)

	useEffect(() => {
		const previousUserId = previousUserIdRef.current

		if (previousUserId && previousUserId !== userId) {
			unsubscribe().catch(err => {
				console.warn('Failed to unsubscribe on user change:', err)
			})
		}

		previousUserIdRef.current = userId || null
	}, [userId, unsubscribe])
}
